import { FilterFormFieldStrategyType } from "@/common/types";
import {
  includedOptions,
  maintenanceSLAOptions,
  purchaseTypeOptions,
} from "../filter-options";
import maintenanceTypeOptions from "../filter-options/maintainanceType.options";

const hardwareFilterForm: FilterFormFieldStrategyType[] = [
  {
    key: "Purchase Type",
    element: {
      label: "Purchase Type",
      name: "Hardware-purchaseType",
      inputType: "select",
      options: purchaseTypeOptions,
      required: false,
    },
  },
  {
    key: "Maintenance Type",
    element: {
      label: "Maintenance Type",
      name: "Hardware-maintenanceType",
      inputType: "select",
      options: maintenanceTypeOptions,
      required: false,
    },
  },
  {
    key: "Maintenance SLA",
    element: {
      label: "Maintenance SLA",
      name: "Hardware-maintenanceSla",
      inputType: "select",
      options: maintenanceSLAOptions,
      required: false,
    },
  },
  {
    key: "Maintenance Status",
    element: {
      label: "Maintenance Status",
      name: "Hardware-maintenanceStatus",
      inputType: "select",
      options: includedOptions,
      required: false,
    },
  },
  {
    key: "License Status",
    element: {
      label: "License Status",
      name: "Hardware-licenseStatus",
      inputType: "select",
      options: includedOptions,
      required: false,
    },
  },
  {
    key: "On-site Delivery Included",
    element: {
      label: "On-site Delivery Included",
      name: "Hardware-onSiteDeliveryIncluded",
      inputType: "select",
      options: includedOptions,
      required: false,
    },
  },
];
export default hardwareFilterForm;
